import { Component, ElementRef, HostBinding, Input, QueryList, ViewChildren } from '@angular/core';
import { NavEntry } from '../nav-entry';

@Component({
  standalone: false,
  selector: 'ul[au-sub-tree-navigation]',
  templateUrl: './sub-tree-navigation.component.html',
})
export class SubTreeNavigationComponent {

  @Input() navigation: NavEntry[] = [];
  @Input() isSubtree = true;
  @Input() route: string | undefined;
  @Input() fragment: string | undefined;

  @HostBinding('class.em-c-tree__list--flush') get _treelistFlush() { return !this.isSubtree; }
  @HostBinding('class.em-js-tree-dropdown') get _treeDropDown() { return this.isSubtree; }
  @HostBinding('attr.role') get _role() { return this.isSubtree ? 'tabpanel' : 'tablist' }
  @HostBinding('class.em-c-tree__list') class = 'em-c-em-c-tree__list';
  @HostBinding('attr.aria-multiselectable') attr = 'em-c-em-c-tree__list';

  @ViewChildren('routeLink') _routeLinks: QueryList<ElementRef<HTMLAnchorElement>> | undefined;
  @ViewChildren(SubTreeNavigationComponent) subTrees: QueryList<SubTreeNavigationComponent> | undefined;

  get routeLinks(): HTMLAnchorElement[] {
    const items: HTMLAnchorElement[] = [];
    items.push(...((this._routeLinks?.map(x => x.nativeElement)) ?? []));
    this.subTrees?.forEach(tree => items.push(...tree.routeLinks));
    return items;
  }

  isActivePage(route: string, fragment: string) {
    return this.route === route && this.fragment === fragment;
  }

}